import { I18nKeys } from 'i18n/keys';
import { defineMessages } from 'react-intl';

export const CommonMessages = defineMessages({
  tenants: {
    id: I18nKeys.Tenants,
    defaultMessage: 'Tenants',
  },
  users: {
    id: I18nKeys.UserSearch,
    defaultMessage: 'Users',
  },
  permissions: {
    id: I18nKeys.Permissions,
    defaultMessage: 'Permissions',
  },
  groupList: {
    id: I18nKeys.GroupList,
    defaultMessage: 'Groups',
  },
  groups: {
    id: I18nKeys.GroupList,
    defaultMessage: 'Groups',
  },
  identityProviders: {
    id: I18nKeys.IdentityProviders,
    defaultMessage: 'Identity Providers',
  },
  profile: {
    id: I18nKeys.Profile,
    defaultMessage: 'Profile',
  },
  builtInRoles: {
    id: I18nKeys.BuiltInRoles,
    defaultMessage: 'Built-in Roles',
  },
  creating: {
    id: I18nKeys.Creating,
    defaultMessage: 'Creating ...',
  },
  create: {
    id: I18nKeys.Create,
    defaultMessage: 'Create',
  },
  name: {
    id: I18nKeys.Name,
    defaultMessage: 'Name',
  },
  clientId: {
    id: I18nKeys.ClientId,
    defaultMessage: 'Client ID',
  },
  entityId: {
    id: I18nKeys.EntityId,
    defaultMessage: 'Entity ID',
  },
  externalIdField: {
    id: I18nKeys.ExternalIdField,
    defaultMessage: 'External ID field',
  },
  externalId: {
    id: I18nKeys.ExternalId,
    defaultMessage: 'External ID ',
  },
  id: {
    id: I18nKeys.Id,
    defaultMessage: 'ID',
  },
  userProfileId: {
    id: I18nKeys.UserProfileId,
    defaultMessage: 'User Profile ID',
  },
  uid: {
    id: I18nKeys.Uid,
    defaultMessage: 'Uid (User ID)',
  },
  email: {
    id: I18nKeys.Email,
    defaultMessage: 'Email',
  },
  emailAddress: {
    id: I18nKeys.EmailAddress,
    defaultMessage: 'Email address',
  },
  phoneNumber: {
    id: I18nKeys.PhoneNumber,
    defaultMessage: 'Phone number',
  },
  rpEntityId: {
    id: I18nKeys.RpEntityId,
    defaultMessage: 'RP entity ID',
  },
  ssoUrl: {
    id: I18nKeys.SsoUrl,
    defaultMessage: 'SSO url',
  },
  userType: {
    id: I18nKeys.UserType,
    defaultMessage: 'User type',
  },
  staff: {
    id: I18nKeys.Staff,
    defaultMessage: 'Staff',
  },
  shoppers: {
    id: I18nKeys.Shoppers,
    defaultMessage: 'Shoppers',
  },
  issuer: {
    id: I18nKeys.Issuer,
    defaultMessage: 'Issuer',
  },
  prompt: {
    id: I18nKeys.Prompt,
    defaultMessage: 'Prompt type',
  },
  edit: {
    id: I18nKeys.Edit,
    defaultMessage: 'Edit',
  },
  disable: {
    id: I18nKeys.Disable,
    defaultMessage: 'Disable',
  },
  enable: {
    id: I18nKeys.Enable,
    defaultMessage: 'Enable',
  },
  emailRequiredError: {
    id: I18nKeys.EmailRequiredError,
    defaultMessage: 'Email is required',
  },
});
